import { SetStateAction, useState } from "react";
import { ModalWithButtons } from "./modal";
import { BlackButton, GreyButton } from "../button";
import { useTranslation } from "react-i18next";
import { NeutralColor } from "node-library/dist/colors";
import { CustomTextInput } from "../inputs";

interface Props {
	open: boolean;
	setOpen: React.Dispatch<SetStateAction<boolean>>;
	proceedAction: () => void;
}

export default function DiscardOrderConfirmModal(props: Props) {
	const { t: translation } = useTranslation();
	const [confirmText, setConfirmText] = useState<string>("");

	const modal: React.ReactNode = (
		<ModalWithButtons
			headerText={""}
			open={props.open}
			setOpen={props.setOpen}
			buttons={[
				<GreyButton
					key="discard-order-cancel-button"
					id="discard-order-cancel-button"
					children={translation("Cancel")}
					onClick={() => {
						props.setOpen(false);
					}}
				></GreyButton>,
				<BlackButton
					key="discard-order-proceed-button"
					id="discard-order-proceed-button"
					children={translation("Discard")}
					disabled={confirmText !== translation("Confirm")}
					onClick={() => {
						setTimeout(() => props.proceedAction(), 1);
						props.setOpen(false);
					}}
				></BlackButton>,
			]}
		>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					gap: "5px",
					alignItems: "center",
					textAlign: "center",
					marginTop: "-10px",
				}}
			>
				<div className="modal-body-icon discard-order-icon"></div>

				<div className="typography-body-02 typography-bold">
					{translation("Discardorder?")}
				</div>
				<div
					className="typography-caption"
					style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
				>
					{translation("DiscardOrderConfirmMessage")}
				</div>
				<div
					className="typography-caption"
					style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
				>
					{translation("CannotUndoAction")}
				</div>
				<CustomTextInput
					id={`delete-modal-confirm-textbox`}
					key={`delete-modal-confirm-textbox`}
					value={confirmText}
					setValue={setConfirmText}
					placeholder={translation("Confirm")}
					type="text"
					required={true}
				></CustomTextInput>
			</div>
		</ModalWithButtons>
	);

	return modal;
}
